var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import Modal from 'react-modal';
import { useHistory } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';
import api from '../../../services/api';
import * as Yup from 'yup';
import styles from './styles.module.scss';
import { Button, InputSelect } from 'template/lib';
Modal.setAppElement('#root');
var ModalBethaTester = function (props) {
    var history = useHistory();
    var _a = useAuth(), login = _a.login, handleLogout = _a.handleLogout;
    var _b = useState([]), companies = _b[0], setCompanies = _b[1];
    var _c = useState(''), companyId = _c[0], setCompanyId = _c[1];
    var _d = useState([]), products = _d[0], setProducts = _d[1];
    var _e = useState(''), productId = _e[0], setProductId = _e[1];
    var _f = useState([]), bethaTestersToEdit = _f[0], setBethaTestersToEdit = _f[1];
    var _g = useState([]), softwares = _g[0], setSoftwares = _g[1];
    var config = {
        headers: { Authorization: "Bearer " + (login === null || login === void 0 ? void 0 : login.token) }
    };
    var bethaTesterSchema = Yup.object().shape({
        companyId: Yup.string().required('Por favor, informe uma empresa.'),
        productId: Yup.string().required('Por favor, informe um produto.'),
        softwareId: Yup.string().required('Por favor, informe um software.')
    });
    var formik = useFormik({
        initialValues: {
            licenseRenovationIds: [],
            companyId: '',
            productId: '',
            licenseRenovationId: '',
            softwareId: ''
        },
        validationSchema: bethaTesterSchema,
        onSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () {
            var payload, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        console.log('SUBMIT', values);
                        payload = __assign({}, values);
                        return [4 /*yield*/, api.put('betha-testers', payload, config)];
                    case 1:
                        _a.sent();
                        formik.resetForm();
                        props.setRefresh(function (prev) { return !prev; });
                        props.handleCloseModalBethaTester();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        if (!login || Date.now() > login.expiresIn * 1000) {
                            handleLogout();
                            history.push('/');
                            return [2 /*return*/];
                        }
                        console.log(err_1);
                        alert('Erro ao cadastrar usuário betha.');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); },
    });
    useEffect(function () {
        if (login && Date.now() > login.expiresIn * 1000) {
            handleLogout();
            history.push('/');
            return;
        }
        if (!login) {
            history.push('/');
            return;
        }
    }, []);
    useEffect(function () {
        if (companyId && productId) {
            api.get("betha-testers/to-edit?companyId=" + companyId + "&productId=" + productId, config).then(function (response) {
                setBethaTestersToEdit(response.data);
                var productsEnabled = response.data
                    .filter(function (item) { return item.isBetha; })
                    .map(function (item) { return item.id; });
                formik.setFieldValue('licenseRenovationIds', productsEnabled);
            });
        }
    }, [companyId, productId]);
    useEffect(function () {
        if (products.length == 1) {
            var selectProductId = document.getElementById('productId');
            if (selectProductId) {
                selectProductId.value = products[0].id;
                selectProductId.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    }, [products]);
    useEffect(function () {
        if (softwares.length == 1) {
            var selectSoftwareId = document.getElementById('softwareId');
            if (selectSoftwareId) {
                selectSoftwareId.value = softwares[0].id;
                selectSoftwareId.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    }, [softwares]);
    useEffect(function () {
        if (companies.length > 0 && props.companyId) {
            var selectCompanyId = document.getElementById('companyId');
            if (selectCompanyId) {
                selectCompanyId.value = props.companyId;
                selectCompanyId.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    }, [companies]);
    useEffect(function () {
        if (props.modalIsOpenBethaTester) {
            setCompanyId(props.companyId);
            api.get('companies/active', config).then(function (response) {
                setCompanies(response.data);
            });
            api.get('helps/products', config).then(function (response) {
                var enabledProducts = response.data.filter(function (product) {
                    return props.enabledProductIds.includes(product.id);
                });
                setProducts(enabledProducts);
            });
            api.get('helps/softwares', config).then(function (response) {
                var enabledSoftwares = response.data.filter(function (software) {
                    return props.enabledSoftwareIds.includes(software.id);
                });
                setSoftwares(enabledSoftwares);
            });
        }
        else {
            resetValues();
        }
    }, [props.modalIsOpenBethaTester]);
    var companySelect = {
        label: 'Empresa',
        options: companies
    };
    var productSelect = {
        label: 'Produto',
        options: products
    };
    var bethaTestersToEditelect = {
        label: 'Usuário/Licença',
        options: bethaTestersToEdit.sort(function (a, b) {
            return a.displayToSelect.localeCompare(b.displayToSelect, "pt-BR", { sensitivity: "base" });
        })
    };
    var softwareSelect = {
        label: 'Software',
        options: softwares
    };
    function resetValues() {
        formik.resetForm();
        setBethaTestersToEdit([]);
        setProductId('');
        setCompanyId('');
    }
    return (_jsx(Modal, __assign({ isOpen: props.modalIsOpenBethaTester, shouldCloseOnOverlayClick: false, onRequestClose: props.handleCloseModalBethaTester, overlayClassName: 'react-modal-overly', className: 'react-modal-content', contentLabel: "Novo Usu\u00E1rio Betha" }, { children: _jsxs("div", { children: [_jsxs("div", __assign({ className: styles.header }, { children: [_jsx("div", {}, void 0), _jsx("h2", __assign({ className: 'font-semibold border-b-2 text-lg' }, { children: "Novo Usu\u00E1rio Betha" }), void 0), _jsx(AiOutlineClose, { title: 'Fechar', className: 'cursor-pointer text-sm', onClick: props.handleCloseModalBethaTester }, void 0)] }), void 0), _jsx("div", __assign({ className: styles.content }, { children: _jsxs("form", __assign({ onSubmit: formik.handleSubmit, className: 'mx-4 my-4' }, { children: [_jsx("div", __assign({ className: 'grid justify-items-start' }, { children: _jsxs("div", __assign({ className: 'grid grid-cols-1 my-2 justify-items-end' }, { children: [_jsx(InputSelect, { onChange: function (e) { formik.handleChange(e); setProductId(e.target.value); }, value: formik.values.productId, name: 'productId', values: productSelect, valueMember: 'id', displayMember: 'name', firstOption: 'Selecione um produto' }, void 0), formik.errors.productId && formik.touched.productId && (_jsx("i", __assign({ className: styles.formikErrors }, { children: formik.errors.productId }), void 0)), _jsx(InputSelect, { onChange: formik.handleChange, value: formik.values.softwareId, name: 'softwareId', values: softwareSelect, valueMember: 'id', displayMember: 'name', firstOption: 'Selecione um software' }, void 0), formik.errors.softwareId && formik.touched.softwareId && (_jsx("i", __assign({ className: styles.formikErrors }, { children: formik.errors.softwareId }), void 0)), _jsx(InputSelect, { onChange: function (e) { formik.handleChange(e); setCompanyId(e.target.value); }, value: formik.values.companyId, name: 'companyId', values: companySelect, valueMember: 'id', displayMember: 'name', firstOption: 'Selecione uma empresa' }, void 0), formik.errors.companyId && formik.touched.companyId && (_jsx("i", __assign({ className: styles.formikErrors }, { children: formik.errors.companyId }), void 0)), _jsx("div", __assign({ className: styles.productList }, { children: bethaTestersToEdit.map(function (licenseRenovation) { return (_jsxs("label", __assign({ className: styles.productItem }, { children: [_jsx("input", { type: "checkbox", checked: formik.values.licenseRenovationIds.includes(licenseRenovation.id), onChange: function (e) {
                                                            var currentLicenseRenovationIds = formik.values.licenseRenovationIds;
                                                            if (e.target.checked) {
                                                                formik.setFieldValue('licenseRenovationIds', __spreadArray(__spreadArray([], currentLicenseRenovationIds), [
                                                                    licenseRenovation.id
                                                                ]));
                                                            }
                                                            else {
                                                                formik.setFieldValue('licenseRenovationIds', currentLicenseRenovationIds.filter(function (id) { return id !== licenseRenovation.id; }));
                                                            }
                                                        } }, void 0), _jsx("span", { children: licenseRenovation.displayToSelect }, void 0)] }), licenseRenovation.id)); }) }), void 0), _jsx("i", __assign({ className: styles.formikErrors }, { children: formik.errors.licenseRenovationIds }), void 0)] }), void 0) }), void 0), _jsx("div", __assign({ className: styles.flexButton }, { children: _jsx(Button, __assign({ type: 'submit' }, { children: "Salvar" }), void 0) }), void 0)] }), void 0) }), void 0)] }, void 0) }), void 0));
};
export default ModalBethaTester;
